import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent, ModalOptions, ModalButton } from '../../components/modal/modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(private dialog: MatDialog) {}

  /**
   * Método principal para exibir modal.
   *
   * Devolve a referência do dialog para quem precisa encadear um segundo modal:
   * o botão executa a `action` e só então fecha, então abrir outro modal dentro
   * da própria `action` empilharia um dialog sobre o que está fechando. Quem
   * encadeia deve usar `afterClosed()`.
   */
  show(options: ModalOptions): MatDialogRef<ModalComponent> {
    return this.dialog.open(ModalComponent, {
      width: '400px',
      maxWidth: '90vw',
      disableClose: false,
      data: options
    });
  }

  // Métodos de conveniência
  error(message: string, title?: string): void {
    this.show({
      type: 'error',
      message,
      title: title || 'Erro',
      buttonText: 'OK',
      showCloseButton: true,
      autoClose: false
    });
  }

  success(message: string, title?: string): void {
    this.show({
      type: 'success',
      message,
      title: title || 'Sucesso',
      buttonText: 'OK',
      showCloseButton: true,
      autoClose: true,
      autoCloseDelay: 3000
    });
  }

  warning(message: string, title?: string): void {
    this.show({
      type: 'warning',
      message,
      title: title || 'Atenção',
      buttonText: 'Entendi',
      showCloseButton: true,
      autoClose: false
    });
  }

  info(message: string, title?: string): void {
    this.show({
      type: 'info',
      message,
      title: title || 'Informação',
      buttonText: 'OK',
      showCloseButton: true,
      autoClose: false
    });
  }

  // Modal personalizado
  custom(options: ModalOptions): MatDialogRef<ModalComponent> {
    return this.show(options);
  }

  // Método compatível com estrutura existente
  async showAlertModal(options: {
    imagemUrl?: string;
    titleText?: string;
    subtitleText?: string;
    listButtons?: ModalButton[];
  }): Promise<void> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ModalComponent, {
        width: '400px',
        maxWidth: '90vw',
        disableClose: false,
        data: {
          ...options,
          type: 'info',
          showCloseButton: true,
          autoClose: false
        }
      });

      dialogRef.afterClosed().subscribe(() => {
        resolve();
      });
    });
  }
}
